// extracted by mini-css-extract-plugin
module.exports = {"container":"FuwgCard_container__3CzX5","wrapper":"FuwgCard_wrapper__3j8Jm","image":"FuwgCard_image__1v3Po","header":"FuwgCard_header__InbEu"};